const buttonSizeDecorator = (size, style, theme, buttonStyle) => {
  const effectiveSize = buttonStyle === 'aux' ? 'aux' : size;
  switch (effectiveSize) {
    case 'large':
    case 'lg':
      return {
        ...style,
        padding: theme.tokens.ComponentBtnSizeLargePadding,
        fontSize: theme.tokens.ComponentBtnSizeLargeFontSize,
        lineHeight: theme.tokens.ComponentBtnSizeLargeLineHeight,
        borderRadius: theme.tokens.ComponentBtnSizeDefaultBorderRadius,
        height: theme.tokens.ComponentBtnSizeLargeHeight,
        '& svg': {
          fontSize: `${theme.tokens.ComponentBtnSizeLargeFontSize} !important`
        }
      };
    case 'small':
    case 'sm':
      return {
        ...style,
        padding: theme.tokens.ComponentBtnSizeSmallPadding,
        fontSize: theme.tokens.ComponentBtnSizeSmallFontSize,
        lineHeight: theme.tokens.ComponentBtnSizeSmallLineHeight,
        borderRadius: theme.tokens.ComponentBtnSizeSmallBorderRadius,
        height: theme.tokens.ComponentBtnSizeSmallHeight,
        '& svg': {
          fontSize: `${theme.tokens.ComponentBtnSizeSmallFontSize} !important`
        }
      };
    case 'aux':
      return {
        ...style,
        padding: theme.tokens.ComponentBtnSizeAuxPadding,
        fontSize: theme.tokens.ComponentBtnSizeAuxFontSize,
        lineHeight: theme.tokens.ComponentBtnSizeAuxLineHeight,
        borderRadius: theme.tokens.ComponentBtnSizeAuxBorderRadius,
        height: theme.tokens.ComponentBtnSizeAuxHeight,
        '& svg': {
          fontSize: `${theme.tokens.ComponentBtnSizeAuxFontSize} !important`
        }
      };
    case 'medium':
    case 'md':
    default:
      return {
        ...style,
        padding: theme.tokens.ComponentBtnSizeDefaultPadding,
        fontSize: theme.tokens.ComponentBtnSizeDefaultFontSize,
        lineHeight: theme.tokens.ComponentBtnSizeDefaultLineHeight,
        borderRadius: theme.tokens.ComponentBtnSizeDefaultBorderRadius,
        height: theme.tokens.ComponentBtnSizeDefaultHeight,
        '& svg': {
          fontSize: `${theme.tokens.ComponentBtnSizeDefaultFontSize} !important`
        }
      };
  }
};
export default buttonSizeDecorator;